import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { IFlightTransaction } from '../../../types/flight';
import { RootState } from '../..';

interface IGetFlightTransactionsResponse {
  status: boolean;
  message: string;
  data: {
    transactionCount: string;
    transactions: IFlightTransaction[];
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetFlightTransactionsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getFlightTransactionsAsync = createAsyncThunk(
  'flights/transactions',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const accountNumberFromStorage = localStorage.getItem('accountNumber');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(
        `/flights/flight/transactions?accountNumber=${accountNumberFromStorage}`,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const flightTransactionsGetSlice = createSlice({
  name: 'flightTransactions/get',
  initialState,
  reducers: {
    resetGetFlightTransactions: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFlightTransactionsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getFlightTransactionsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetFlightTransactionsResponse;
      })
      .addCase(getFlightTransactionsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetFlightTransactionsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetFlightTransactions } =
  flightTransactionsGetSlice.actions;

export default flightTransactionsGetSlice.reducer;
